export const fpsOptions = [
  {
    name: '12',
    value: '12'
  },
  {
    name: '15',
    value: '15'
  },
  {
    name: '24',
    value: '24'
  },
  {
    name: '29',
    value: '29'
  },
  {
    name: '30',
    value: '30'
  },
  {
    name: '50',
    value: '50'
  },
  {
    name: '60',
    value: '60'
  }
]

export const videoFormatOptions = [
  {
    name: 'mp4',
    value: 'mp4'
  },
  {
    name: 'gif',
    value: 'gif'
  }
]



// WEBPACK FOOTER //
// ./src/constants/CreativeUnits/index.js